import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../components";

const GenerateShipmentFooter = ({ onCancel, onSave, isSaveDisabled, primaryButtonLabel = 'Primary Action' }) => {
    const { i18n } = useTranslation()
    // Track whether the primary action is in-flight so the button shows a
    // spinner instead of looking inert during the /conclude or /generate-label
    // round-trip (can take seconds, especially scenario B with N labels).
    const [saving, setSaving] = useState(false)
    const handleSaveClick = async () => {
        if (saving) return
        setSaving(true)
        try {
            await onSave()
        } finally {
            setSaving(false)
        }
    }
    return (
        <footer className="flex flex-col justify-center gap-4 w-full h-full p-4">
            <div className="flex justify-end h-12 gap-4">
                <Button
                    type="secondary"
                    onClick={onCancel}
                    disabled={saving}
                    className="min-w-1/4"
                >
                    <span className="text-xl">{i18n.t('generate_shared_label.cancel')}</span>
                </Button>

                <Button
                    disabled={isSaveDisabled || saving}
                    onClick={handleSaveClick}
                    className="min-w-1/4"
                >
                    <span className="text-xl inline-flex items-center gap-2">
                        {saving && (
                            <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24" fill="none" aria-hidden>
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
                                <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                            </svg>
                        )}
                        {saving ? i18n.t('generate_shipment.multi_box.finalizing') : primaryButtonLabel}
                    </span>
                </Button>
            </div>
        </footer>
    )
}

export default GenerateShipmentFooter
